import { Pipe, PipeTransform } from '@angular/core';
import { ImageUrlService } from '../service/image-url.service';

@Pipe({
  name: 'imageUrl',
  standalone: true
})
export class ImageUrlPipe implements PipeTransform {
  constructor(private imageUrlService: ImageUrlService) {}
  transform(value?: string | null): string {
    return this.imageUrlService.buildUrl(value ?? '');
  }
}
